import { useScrollReveal, revealClass } from '../../../hooks/useScrollReveal';

export default function AboutSection() {
  const { ref: headingRef, isVisible: headingVisible } = useScrollReveal<HTMLDivElement>();
  const { ref: quoteRef, isVisible: quoteVisible } = useScrollReveal<HTMLDivElement>();
  const { ref: cardsRef, isVisible: cardsVisible } = useScrollReveal<HTMLDivElement>({ threshold: 0.1 });

  return (
    <section id="about" className="bg-white py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div ref={headingRef} className={`text-center mb-12 ${revealClass(headingVisible)}`}>
          <p className="text-xs uppercase tracking-widest text-gray-500 mb-6">APPROACH</p>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-8">
            About My Work
          </h2>
        </div>

        <div className="prose prose-lg max-w-none">
          <div ref={quoteRef} className={revealClass(quoteVisible, 100)}>
            <p className="font-serif text-2xl lg:text-3xl text-gray-800 leading-relaxed text-center mb-12">
              I work across research, publishing, and cultural documentation to deepen public understanding of Nigeria's historical landscape. Through archival development, media platforms, exhibitions, and heritage-driven collaborations, I transform fragmented histories into structured, accessible knowledge systems for both scholarly and contemporary audiences
            </p>
          </div>

          <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            <div className={`text-center ${revealClass(cardsVisible, 0)}`}>
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-search-line text-4xl text-accent"></i>
              </div>
              <h3 className="font-serif text-xl font-semibold text-gray-900 mb-3">Researcher</h3>
              <p className="font-sans text-sm text-gray-600 leading-relaxed">
                Conducts rigorous historical inquiry across media, oral history, and archival sources. Documents overlooked figures, movements, and institutions within Nigeria's cultural landscape. Structures fragmented records into coherent, verifiable bodies of knowledge
              </p>
            </div>

            <div className={`text-center ${revealClass(cardsVisible, 150)}`}>
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-gallery-line text-4xl text-accent"></i>
              </div>
              <h3 className="font-serif text-xl font-semibold text-gray-900 mb-3">Curator</h3>
              <p className="font-sans text-sm text-gray-600 leading-relaxed">
                Shapes exhibitions and cultural narratives that contextualize historical memory within contemporary discourse. Develops concept-driven projects that connect archives, identity, and public engagement. Transforms research into immersive, intellectually grounded cultural experiences
              </p>
            </div>

            <div className={`text-center ${revealClass(cardsVisible, 300)}`}>
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-archive-line text-4xl text-accent"></i>
              </div>
              <h3 className="font-serif text-xl font-semibold text-gray-900 mb-3">Archivist</h3>
              <p className="font-sans text-sm text-gray-600 leading-relaxed">
                Builds and preserves digital and physical repositories of cultural history. Applies innovative archival methods to safeguard endangered records and materials. Ensures historical memory remains accessible, searchable, and relevant for future generations
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
